(function ($) {
  'use strict';

  $(document).ready(function () {
    $('.js-trainers-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
}(jQuery));
